import { useQueries, useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';

export const overviewActivityPendingWorkspaceFilter = ({
  activityType,
  stage,
  terminationReason,
}) => activityType === 'lock_box' && stage == 'proposal' && !terminationReason;

export const overviewActivityAllPendingWorkspaceFilter = ({
  activityType,
  stage,
  terminationReason,
}) => activityType === 'lock_box' && (stage == 'proposal' || terminationReason);

/** @category Entities and Profiles */
export function usePendingWorkspaces(includeRejected) {
  const tokenizedApi = useTokenizedApi();

  const profiles =
    useQuery(tokenizedApi.entities.profilesQuery()).data?.allProfiles || [];

  const activityOverview = useQueries(
    profiles.map(({ id: profileId }) => ({
      ...tokenizedApi.activity.activityOverviewQuery({
        profileId,
      }),
      select: (activities) =>
        activities
          .filter(
            includeRejected
              ? overviewActivityAllPendingWorkspaceFilter
              : overviewActivityPendingWorkspaceFilter,
          )
          .map((item) => ({ ...item, profileId })),
    })),
  ).flatMap(({ data }) => data || []);

  const allProfilesActivity = useQueries(
    activityOverview.map(({ profileId, activityId, lockboxId, dateModified }) =>
      tokenizedApi.activity.activityEventQuery({
        profileId,
        lockboxId,
        activityId,
        dateModified,
      }),
    ),
  ).flatMap(({ data }) => data || []);

  return tokenizedApi.activity.filterPendingWorkspaces(allProfilesActivity);
}
